import { toAbsoluteUrl } from '../../../helpers';

export function FallbackView() {
  return (
    <div className="splash-screen">
      <img src={toAbsoluteUrl('/media/logos/dep_icon.png')} alt="Logo" />
      <span>Yükleniyor ...</span>
    </div>
  );
}
